import React from "react";
import {AuthorDetails} from "./AuthorDetails";

export const AuthorFunction = ({authorDetails}) => {
    if (!authorDetails.function) return null;

    return <AuthorDetails className="t-function">{authorDetails.function}</AuthorDetails>
};